import { WhatsAppIcon } from "./WhatsAppIcon";
import { getWaLink, WA_MESSAGES } from "@/lib/joffreys-whatsapp";

export function FloatingWA() {
  return (
    <a
      href={getWaLink(WA_MESSAGES.floating)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="كلّمنا الآن على واتساب"
      className="group fixed bottom-6 right-6 z-50 flex h-16 w-16 items-center justify-center rounded-full text-white shadow-2xl transition-transform hover:scale-110 pulse-ring"
      style={{ backgroundColor: "#25d366" }}
    >
      <WhatsAppIcon className="h-8 w-8" />
      <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-full bg-charcoal px-3 py-1.5 text-xs font-bold text-cream opacity-0 group-hover:opacity-100 transition">
        كلّمنا الآن
      </span>
    </a>
  );
}
